/** @format */

import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { toast } from 'react-toastify';
import SendIcon from "@mui/icons-material/Send";
import LoadingButton from "@mui/lab/LoadingButton";
import TextField from "@mui/material/TextField";
import SelectDropDown from "./SelectDropdown";
import axios from "axios";
import { useEffect, useState } from "react";

export default function AddToProductCategoryAndSubCategory() {
  const [addCatloading, setCatLoading] = useState(false);
  const [addSubCatloading, setSubCatLoading] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [categoryDesc, setCategoryDesc] = useState("");
  const [subCategoryName, setSubCategoryName] = useState("");
  const [subCategoryDesc, setSubCategoryDesc] = useState("");
  const [productCategories, setProductCategories] = useState([]);
  const [selectedProductCategory, setSelectedProductCategory] =
    useState("");

  function getProductCategories() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/masterdata/getAllProductCategories`)
      .then((productCategories) => {
        const formatedProductCategory = productCategories.data.list.map(
          (category) => {
            return { id: category.id, name: category.name, value: category.id };
          }
        );
        setProductCategories(formatedProductCategory);
        console.log(formatedProductCategory);
        console.log(productCategories.data.list);
      })
      .catch((err) => console.log(err));
  }
  async function addToProductCategoryList(event) {
    setCatLoading(true);
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/masterdata/addProductCategory?categoryName=${data.get(
          "category-name"
        )}&categoryDescription=${data.get("category-description")}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(response.data);
      setCatLoading(false);
      toast.success("Product Category successfully added!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      setCatLoading(false);
      toast.error(`${err.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    setCategoryName("");
    setCategoryDesc("");
    getProductCategories();
  }

  async function addToProductSubCategoryList(event) {
    setSubCatLoading(true);
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/masterdata/addProductSubCategory?categoryId=${selectedProductCategory}&subCategoryName=${data.get(
          "sub-category-name"
        )}&subCategoryDescription=${data.get("sub-category-description")}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(response.data);
      setSubCatLoading(false);
      toast.success("Product subcategory successfully added!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      setSubCatLoading(false);
      toast.error(`${err.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    setSubCategoryName("");
    setSubCategoryDesc("");
    setSelectedProductCategory("");
  }

  useEffect(() => {
    getProductCategories();
  }, []);

  return (
    <Box
      sx={{
        width: "97%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          xl={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card sx={{ maxWidth: 420, height: "100%" }}>
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Add Item into Product Category List
              </Typography>
              <Box
                component="form"
                onSubmit={addToProductCategoryList}
                sx={{ mt: 1 }}
              >
                <TextField
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  margin="normal"
                  required
                  fullWidth
                  id="category-name"
                  label="Category Name"
                  name="category-name"
                />
                <TextField
                  value={categoryDesc}
                  onChange={(e) => setCategoryDesc(e.target.value)}
                  margin="normal"
                  required
                  fullWidth
                  id="category-description"
                  label="Category Description"
                  name="category-description"
                />
                <LoadingButton
                  endIcon={<SendIcon />}
                  loading={addCatloading}
                  loadingPosition="end"
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2, bgcolor: "secondary.main" }}
                >
                  Add
                </LoadingButton>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          xl={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card sx={{ maxWidth: 420, height: "100%" }}>
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Add Item into Sub Category List
              </Typography>
              <Box
                component="form"
                onSubmit={addToProductSubCategoryList}
                sx={{ mt: 1 }}
              >
                <SelectDropDown
                  options={productCategories}
                  dropdownLabel="Product Category"
                  value={selectedProductCategory}
                  setValue={setSelectedProductCategory}
                />

                <TextField
                  value={subCategoryName}
                  onChange={(e) => setSubCategoryName(e.target.value)}
                  margin="normal"
                  required
                  fullWidth
                  id="sub-category-name"
                  label="Sub Category Name"
                  name="sub-category-name"
                />
                <TextField
                  value={subCategoryDesc}
                  onChange={(e) => setSubCategoryDesc(e.target.value)}
                  margin="normal"
                  required
                  fullWidth
                  id="sub-category-description"
                  label="Sub Category Description"
                  name="sub-category-description"
                />
                <LoadingButton
                  endIcon={<SendIcon />}
                  loading={addSubCatloading}
                  loadingPosition="end"
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2, bgcolor: "secondary.main" }}
                >
                  Add
                </LoadingButton>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
